module.exports = __webpack_public_path__ + "img/pro-m-slider21.e0b1e2d1.png";